<template>
  <div class="real-estate-view">
    <v-container>
      <Real_Service />
    </v-container>
  </div>
</template>

<script>
import Real_Service from "../components/Real_Service/Real_Service.vue";

export default {
  components: {
    Real_Service,
  },
};
</script>

<style lang="scss" scoped>
.real-estate-view {
  width: 100%;
  background: #f5f5f5;
  min-height: 100vh;
  padding: 32px 0;
}

@media (max-width: 600px) {
  .real-estate-view {
    padding: 24px 0;
  }
}
</style>
